import { ArrowLeft, LockKeyhole } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

type AccessDeniedLocationState = {
  from?: string;
};

export default function AccessDenied() {
  const location = useLocation();
  const state = location.state as AccessDeniedLocationState | null;

  return (
    <div className="page-content tailwind-prefix">
      <div className="mx-auto flex min-h-[520px] max-w-2xl items-center justify-center px-4 py-10">
        <section className="w-full rounded-xl border border-slate-200 bg-white p-6 text-center shadow-sm dark:border-slate-700 dark:bg-slate-900 sm:p-10">
          <span className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-amber-50 text-amber-700 dark:bg-amber-950/50 dark:text-amber-300">
            <LockKeyhole className="h-7 w-7" aria-hidden="true" />
          </span>
          <h1 className="mb-2 text-2xl font-semibold text-slate-950 dark:text-slate-50">
            You do not have access to this page
          </h1>
          <p className="mx-auto mb-6 max-w-lg text-sm leading-6 text-slate-600 dark:text-slate-300">
            Your account role or permissions do not allow this page. If you believe this is incorrect, contact your company owner or platform administrator.
          </p>
          {state?.from ? (
            <p className="mb-6 break-all text-xs text-slate-500 dark:text-slate-400">
              Requested page: {state.from}
            </p>
          ) : null}
          <Link
            to="/profile"
            className="inline-flex min-h-10 items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white no-underline transition hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 dark:bg-blue-500 dark:hover:bg-blue-600 dark:focus-visible:ring-offset-slate-900"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Go to my profile
          </Link>
        </section>
      </div>
    </div>
  );
}
